import React, { Component } from "react";
import { element } from "prop-types";
import IntlMessages from "util/IntlMessages";
import { isAbsolute } from "path";
import logo from "assets/images/nail_salon2.jpg";
// import { url } from "inspector";

const OverlayImage = ({ topText, sourcePath , test}) => {
  topText = "Book your next \n salon appointment, \n quickly and easily!";
  sourcePath = logo;
  const background = {
    height: "55%",
    width: "100%",
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
  };
  const textStyle = {
    position: "absolute",
    top: "40px",
    left: "50px",
    fontSize: "34px",
    color: "#EA33A6",
    fontStyle: "italic",
  };

  return (
    // <div className="row">
    //   <div className="col">
    //     <div style={{ width: "100%", marginTop: "-10px" }} className="img-fluid banner-img">
    //       <h1 style={textStyle}>
    //         {" "}
    //         {topText.split("\n").map((i, key) => (
    //           <div key={key}>{i}</div>
    //         ))}
    //       </h1>
    //       <img style={background} responsive="true" src={sourcePath} />
    //     </div>
    //   </div>
    // </div>
    <header className="masthead text-center text-white v2">
        <div className="masthead-content">
            <div className="container">
                <h1 className="masthead-heading mb-0">Book Your Next Salon Appointment</h1>
                <h2 className="masthead-subheading mb-0">Quickly and Easily!</h2>
                <a className="btn btn-primary border rounded-0 btn-xl rounded-pill mt-5 btn-main" role="button" href="#" onClick={test}>Get Started</a></div>
        </div>
    </header>
  );
};

export default OverlayImage;



// WEBPACK FOOTER //
// ./components/OverlayImage/index.js